import { PaymentRecipient } from "../../services/payments";

type Recipient = Pick<PaymentRecipient, "status" | "statusReason" | "kycLinkAvailable">;

// Pagar.me's own codes (additional_documents_required, fraud) are not a reason a person reads; one someone wrote is
// (words with a capital, spaces, accents)
export const isProviderCode = (reason: string) => /^[a-z0-9]+(_[a-z0-9]+)*$/.test(reason);

// Every new registration goes through Pagar.me's KYC: what's missing then is only the proof of life
export const isKycStep = (recipient: Recipient) =>
  recipient.status === "needs_info" &&
  (!!recipient.kycLinkAvailable || recipient.statusReason === "additional_documents_required");

// What the API names a registration Pagar.me suspended, blocked or deactivated after approving it (no reason of its own)
const STOPPED = ["suspended", "blocked", "inactive"];

/** Refused because the provider stopped a registration it had approved (not a review that said no) */
export const isStopped = (recipient: Recipient) =>
  recipient.status === "refused" && STOPPED.includes(recipient.statusReason ?? "");

/** The status a person reads: "kyc" (Falta a prova de vida) instead of "needs_info" when that's all that's missing */
export const recipientStatusKey = (recipient: Recipient) => (isKycStep(recipient) ? "kyc" : recipient.status);
